import { Box, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';
import SpinnerSuspense from 'design-system/atoms/spinner-suspense';
import Breadcrumbs, {
  BreadcrumbsProps,
} from 'design-system/molecules/breadcrumbs';
import SubnavButtonGroups, {
  SubnavButtonGroupProps,
} from 'design-system/atoms/subnav-button-groups';
import ErrorBoundary from '../../local_design_system/molecules/ErrorBoundary';
import { useContainerTopValue } from '../../hooks/useContainerTopValue';
import { useLastScrollDirection } from '../../hooks/useScrollDirection';

export default function LayoutHeader({
  breadcrumbs,
  buttonGroups,
  children,
}: {
  breadcrumbs?: BreadcrumbsProps['breadcrumbs'];
  buttonGroups?: SubnavButtonGroupProps['buttonGroups'];
  children?: ReactNode;
}) {
  const { containerRef, containerTopValue } = useContainerTopValue();
  const scrollDirection = useLastScrollDirection();
  return (
    <Flex
      flex="1"
      direction="column"
      alignItems="stretch"
      gap={4}
      ref={containerRef}
    >
      <Box
        flex={0}
        padding={4}
        borderRadius="3xl"
        background="white"
        transition="top 0.3s"
        boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.06), 0 -32px 0 40px #f7f7f7"
        position="sticky"
        top={scrollDirection === 'up' ? `${containerTopValue}px` : '-80px'}
        zIndex={30}
      >
        <Flex gap={2} alignItems="baseline">
          {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
          {buttonGroups && <SubnavButtonGroups buttonGroups={buttonGroups} />}
        </Flex>
      </Box>
      <Flex direction="column" flex="1">
        <ErrorBoundary>
          <SpinnerSuspense>{children}</SpinnerSuspense>
        </ErrorBoundary>
      </Flex>
    </Flex>
  );
}
